module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"filters":"Filter","filtersActive":"{count} Filter aktiv | {count} Filter aktiv","resetAll":"Alle zurücksetzen","close":"Schließen"},"en":{"filters":"Filters","filtersActive":"{count} filter active | {count} filters active","resetAll":"Reset All","close":"Close"}}')
  delete Component.options._Ctor
}
